<template>
  <div class="sur-qtext">
    <p class="q-title title-bold">{{ questionText }}</p>

    <!-- childs quantity -->
    <div class="sur-qtext">
      <vs-row v-for="opt in options" :key="opt.value">
        <vs-button
            type="border"
            :ref="'btn_' + index"
            class="btnOtion btn-block mb-2"
            @click="ChooseOption(opt.value)"
        >{{ opt.text }}
        </vs-button
        >
      </vs-row>
    </div>


    <div v-show="showDependents" id="dependents" class="mt-3 py-3 navegation-orientation">
      <vs-row vs-justify="space-between"
              vs-type="flex"
              v-for="(ans, index) in lines"
              :key="index"
              class="py-3 border-top">
        <vs-col vs-lg="3" class="form-group mb-0">
          <select class="form-control" color="#038835" id="exampleFormControlSelect1" v-model="birth[index]">
            <option v-for="(item, index) in optIdade" :key="index" :value="item.value">
              {{ item.text }}
            </option>
          </select>
        </vs-col>
        <vs-col vs-lg="8">
          <input
              type="text"
              class="form-control"
              :placeholder="$t('full_name')"
              v-model="name[index]"
              @keyup="changeName()"
          />
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Survey-childs",
  data: () => ({
    optIdade: [
      {text: "Idade *", value: 0},
      {text: "1", value: 1},
      {text: "2", value: 2},
      {text: "3", value: 3},
      {text: "4", value: 4},
      {text: "5", value: 5},
      {text: "6", value: 6},
      {text: "7", value: 7},
      {text: "8", value: 8},
      {text: "9", value: 9},
      {text: "10", value: 10},
      {text: "11", value: 11}
    ],
    qtAnwser: "",
    dataOk: false,
    showDependents: false,
    qtChilds: 0,
    lines: [],
    birth: [],
    name: []
  }),
  watch: {
    birth: function () {
      this.MountAnswer();
      this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
    }
  },
  directives: {},
  mounted() {
    //this.focusInput();
  },
  created() {
    if (this.$store.getters.answerValue(this.questionId)) {
      var Anwser = this.$store.getters.answerValue(this.questionId);
      var s = Anwser.split(";");
      this.SetOptions(s);
    }
  },
  updated() {
    // this.focusInput();
  },
  props: {
    questionText: {type: String},
    questionId: {type: Number},
    options: []
  },
  computed: {
    maxChilds: function () {
      return this.qtChilds;
    }
  },
  methods: {
    SetOptions(opt) {
      if (opt[0] == 0) {
        this.qtAnwser = opt;
      } else {
        this.qtChilds = opt[0];
        this.lines = [];
        this.birth = [];
        this.name = []

        for (var i = 1; i <= this.qtChilds; i++) {
          var resp = opt[i].split(":");

          this.lines.push("");
          this.birth.push(resp[1]);
        }

        this.remountList();
        this.showDependents = true;
      }
    },
    remountList() {
      this.lines = [];
      for (var i = 0; i < this.qtChilds; i++) this.lines.push("");
    },
    ChangeIdade() {
      this.MountAnswer();
      this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
    },
    changeName() {
      this.MountAnswer();
      this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
    },
    MountAnswer() {
      this.qtAnwser = this.qtChilds + ";";
      for (var i = 0; i < this.qtChilds; i++) {
        this.qtAnwser = this.qtAnwser + this.birth[i] + ":" + this.name[i] + ";";
      }
    },
    focusInput() {
      // this.$refs.fc.$el.focus();
    },
    ChooseOption1(opt) {
      this.qtAnwser = opt;
      if (opt === 0) this.enterKey();
      else {
        this.qtChilds = opt;

        for (var i = 0; i < opt; i++) {
          this.birth.push(0);
        }

        this.showDependents = true;
      }
    },
    ChooseOption(opt) {
      if (opt === 0) {
        this.qtAnwser = opt
        this.enterKey();
      } else {
        this.qtChilds = opt
        this.lines = []
        this.birth = []
        this.name = []

        for (var i = 0; i < opt; i++) {
          this.lines.push("")
          this.birth.push(0)
          this.name.push('')
        }

        this.showDependents = true;
      }
    },
    allKeys() {
      this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
    },
    enterKey() {
      this.$emit("QuestionAnwered", this.qtAnwser, this.questionId);
    }
  }
};
</script>

<style scoped>
.title-bold{
  font-family:'OxaniumBold';
}
/* .selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.btnOtion {
  width: 40px;
}

.inp {
  background-color: white;
}

.q-title {
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #40424a;
}

.q-text-answer {
  width: 351px;
  height: 40px;
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: #40424a;
}

.q-text-answer .text-style-1 {
  color: #bf9f61;
}*/
.c-select-childs .vs-button-text {
  color: #212529;
}
</style>
